<template>
  <CrudForm :title="title" :labelSubmit="labelSubmit" :storeName="storeName" :parentStoreName="parentStoreName"
    :parentUrlKey="parentUrlKey" :submit="submit_message" :status="status" labelBack="Atrás" :urlBackSpot="urlBackSpot"
    :canCancel="false" canCancelMessage :breadcrumbs="[
      {
        text: 'Spots y vehículos',
        disabled: false,
        href: '/admin/notifications_cms'
      },
      {
        text: '...',
        disabled: false,
        href: '#'
      },
      {
        text: 'Enviar notificacion',
        disabled: true,
        href: '#'
      }
    ]">
    <ValidationObserver ref="validator" v-slot="{ }">
      <v-row no-gutters justify="center">
        <v-col cols="6">
          <v-row no-gutters>
            <v-col class="py-0 px-2">
              <ValidationProvider ref="title" rules="required" v-slot="{ errors }">
                <div class="label-base pb-1">Tipo de email</div>
                <v-select :error-messages="errors" v-model="data.type" :items="['Rechazo', 'Reporte']"
                  label="Tipo de email" solo hide-details="auto" class="input-base" append-icon="$caretDownFormIcon" />
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col class="py-0 px-2">
              <ValidationProvider ref="title" rules="required" v-slot="{ errors }">
                <div class="label-base pb-1">Titulo</div>
                <v-text-field label="Titulo" :error-messages="errors" v-model="data.title" solo hide-details="auto"
                  class="input-base" />
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col class="py-0 px-2">
              <div class="label-base pb-1">Descripción Push</div>
              <ValidationProvider ref="description" rules="required" v-slot="{ errors }">
                <v-textarea :error-messages="errors" v-model="data.description_push" solo placeholder="Descripción Push"
                  hide-details="auto" class="text-tarea-base" rows="8">
                </v-textarea>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col class="py-0 px-2">
              <div class="label-base pb-1">Descripción Email</div>
              <ValidationProvider ref="description" rules="required" v-slot="{ errors }">
                <v-textarea :error-messages="errors" v-model="data.description_email" solo
                  placeholder="Descripción email" hide-details="auto" class="text-tarea-base" rows="8">
                </v-textarea>
              </ValidationProvider>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapState } from "vuex";
import CrudForm from "@/components/Crud/CrudForm";
import CrudFormMixin from "@/mixins/crud_form";
import swal from "sweetalert";
export default {
  mixins: [CrudFormMixin],
  components: {
    ValidationProvider,
    ValidationObserver,
    CrudForm,
  },
  computed: {
    ...mapState({
      status: (state) => state.Spots.status,
    }),
  },
  async created() {
    const { spot_id } = this.$route.params;
    if (spot_id) {
      const spot = await this.$store.dispatch("Spots/show", spot_id);
      this.title = "Enviar notificacion: " + spot.address;
      this.data.user_id = spot.user_id.id;
      this.data.spot_id = spot_id;
    }
    this.urlBackSpot = `/admin/notifications_cms/edit/${spot_id}`;
  },
  data() {
    return {
      parentStoreName: "Spot_helps",
      parentUrlKey: "spot_help_id",
      storeName: "Spots",
      title: "Message",
      data: {
        user_id: "",
        title: "Soporte IZI Park",
        description_push: "",
        description_email: "",
        spot_id: "",
        type: "Reporte",
      },
      urlBackSpot: "",
    };
  },
  watch: {},
  methods: {
    async submit_message() {
      const self = this;
      let valid = await self.$refs.validator.validate();
      if (valid) {
        let saveUrl = `Spots/create_message`;
        self.$store
          .dispatch(saveUrl, self.data)
          .then(function () {
            swal("Notificación Enviada", "exitosamente!!", "success", {
              timer: 3000,
            });
            self.$router.push(self.urlBackSpot);
          })
          .catch(function (response) {
            for (const i in response.errors) {
              try {
                eval("self.$refs." + i + ".setErrors(response.errors[i]);");
              } catch (error) {
                //
              }
            }
          });
      }
    },
  },
};
</script>
